import { SecretSalt } from "@/types/cryptography";
import { hexToArrayBuffer } from "@/utils/crypto";
import { decryptData } from "../systems/symmetric";

export const decryptPortfolioAssets = async (
  secret: SecretSalt,
  encryptedAssets: {
    encryptedId: string;
    data: string | null;
  }[]
) => {
  if (!encryptedAssets) {
    throw new Error("No assets provided.");
  }

  // Decrypt all encrypted UUIDs.
  const promises = encryptedAssets.map(async ({ data, encryptedId }) => {
    const decryptedData = data ? JSON.parse(await decryptData(secret, hexToArrayBuffer(data))) : null;
    const decryptedId = await decryptData(secret, hexToArrayBuffer(encryptedId));

    return {
      data: decryptedData,
      uuid: decryptedId,
    };
  });

  return await Promise.all(promises);
};
